import * as THREE from 'three'

export default function scaleAnimationPositions(clip, scaleFactor) {
  // Create a new clip to avoid mutating original animations
  const scaledTracks = clip.tracks.map(track => {
    // We only want to scale position tracks
    if (track.name.endsWith('.position')) {
      // Clone the track so we don't mutate original
      const scaledTrack = track.clone()

      // Scale each keyframe position value
      for (let i = 0; i < scaledTrack.values.length; i += 3) {
        scaledTrack.values[i] *= scaleFactor.x
        scaledTrack.values[i + 1] *= scaleFactor.y
        scaledTrack.values[i + 2] *= scaleFactor.z
      }

      return scaledTrack
    }

    return track.clone()
  })

  return new THREE.AnimationClip(clip.name, clip.duration, scaledTracks)
}
